"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: unset;\n  margin-right: 0;\n\n  > span:last-child {\n    margin-top: 14px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var StyledFormControlLabel = (0, _styledComponents.default)(_core.FormControlLabel)(_templateObject());

var FormControlLabel = function FormControlLabel(props) {
  return _react.default.createElement(StyledFormControlLabel, props);
};

var _default = FormControlLabel;
exports.default = _default;